export const FEATURE_NAME = '@zerops/zef/state-switcher';
